<script>
export default {
  props: [ 'weekToReview' ],
}
</script>

<template>
  <v-table v-if="weekToReview" density="compact" class="border">
    <thead>
    <tr class="bg-grey-lighten-3">
      <th v-for="d in weekToReview" :key="d.weekday" class="border text-center">{{d.weekday}}</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td v-for="d in weekToReview" :key="d.day" class="border text-center py-1">{{d.month}} {{d.day}}</td>
    </tr>
    </tbody>
  </v-table>
</template>

<style scoped lang="scss">

</style>
